var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRailwayStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#Gradiente_sem_nome_19);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_19",
    "data-name": "Gradiente sem nome 19",
    x1: 96,
    y1: 256.21,
    x2: 416,
    y2: 256.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0072fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a076"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Railway_Station"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416,304V112c-.05-44.16-35.84-79.95-80-80h-160c-44.16.05-79.95,35.84-80,80v192c.06,37.7,26.42,70.26,63.28,78.18l-44.93,73.49c-4.84,7.4-2.76,17.31,4.63,22.15,7.4,4.84,17.31,2.76,22.15-4.63.18-.28.35-.56.51-.84l14.9-24.34h198.93l14.88,24.34c4.37,7.68,14.14,10.36,21.82,5.99s10.36-14.14,5.99-21.82c-.16-.29-.33-.57-.51-.84l-44.93-73.49c36.86-7.92,63.22-40.47,63.28-78.18h0ZM176,320c-8.84,0-16-7.16-16-16s7.16-16,16-16,16,7.16,16,16-7.16,16-16,16ZM176.11,416l19.57-32h120.66l19.57,32h-159.79ZM320,304c0-8.84,7.16-16,16-16s16,7.16,16,16-7.16,16-16,16-16-7.16-16-16ZM368,208c0,17.67-14.33,32-32,32h-160c-17.67,0-32-14.33-32-32v-96c0-17.67,14.33-32,32-32h160c17.67,0,32,14.33,32,32v96Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRailwayStation);
export default __webpack_public_path__ + "static/media/railway-station.1a7daa5828e37b37734c1af21635859d.svg";
export { ForwardRef as ReactComponent };